// SerialDetailModal.js
import React from "react";
import { Modal, Button, Tabs, Space, Tag } from "antd";
import OrderInfo from "./OrderInfo";
import TransferHistory from "./TransferHistory";
import SerialHistory from "./SerialHistory";


const SerialDetailModal = ({ 
  visible, 
  onClose, 
  selectedSerial, 
  transferHistory, 
  transferHistoryLoading,
  serialHistory,
  serialHistoryLoading,
}) => {
  if (!selectedSerial) {
    return null;
  }

  const getStatusColor = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'activo':
        return 'green';
      case 'facturado':
        return 'blue';
      case 'prestado':
        return 'orange';
      case 'anulado':
        return 'red';
      default:
        return 'default';
    }
  };

  const items = [
   
    {
      key: '2',
      label: 'Información de Orden',
      children: <OrderInfo selectedSerial={selectedSerial} />,
    },
    {
      key: '3',
      label: 'Historial de Traslado',
      children: (
        <TransferHistory 
          transferHistory={transferHistory} 
          transferHistoryLoading={transferHistoryLoading}
        />
      ),
    },
    {
      key: '4',
      label: 'Historial del Serial',
      children: (
        <SerialHistory
          serialHistory={serialHistory}
          selectedSerial={selectedSerial}
          loading={serialHistoryLoading}
        />
      ),
    }
  ];

  return (
    <Modal
      title={
        <Space>
          Detalles del Serial: {selectedSerial?.serial || ""}
          <Tag color={getStatusColor(selectedSerial?.estado?.estado)}>
            {selectedSerial?.estado?.estado?.toUpperCase() || "N/A"}
          </Tag>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Cerrar
        </Button>
      ]}
      width={800}
    >
      <Tabs
        defaultActiveKey="1"
        items={items}
        style={{ marginTop: -16 }}
      />
    </Modal>
  );
};

export default SerialDetailModal;